import React, { useState } from 'react';
import { useStyletron } from 'baseui';
import { EmptyState } from './empty-state';
import { ItemAccordionSection } from './item-accordion-section';
import { RemainingItemsContainer } from './styled-components';
import type { RemainingItemsPanelProps } from './types';
import { groupItems, splitItems } from './utils';
const ACCORDION_SECTIONS = ({
  PENDING: 'pending',
  ERRORS: 'errors'
} as const);
type AccordionSection = (typeof ACCORDION_SECTIONS)[keyof typeof ACCORDION_SECTIONS] | null;
export const RemainingItemsPanel = ({
  items,
  itemCount,
  navigationConfig,
  renderItemActions,
  groupingConfig,
  validationState
}: RemainingItemsPanelProps) => {
  const {
    pendingItems,
    errorItems
  } = splitItems(items);
  const [, theme] = useStyletron();
  const groupedPendingItems = groupItems(pendingItems, groupingConfig);
  const groupedErrorItems = groupItems(errorItems, groupingConfig);
  const getInitialExpandedSection = (): AccordionSection => {
    if (pendingItems.length > 0) return ACCORDION_SECTIONS.PENDING;
    if (errorItems.length > 0) return ACCORDION_SECTIONS.ERRORS;
    return null;
  };
  const [expandedSection, setExpandedSection] = useState<AccordionSection>(getInitialExpandedSection());
  const toggleSection = (section: AccordionSection) => {
    setExpandedSection(expandedSection === section ? null : section);
  };
  if (itemCount === 0) {
    return <EmptyState />;
  }
  return <RemainingItemsContainer style={{
    padding: theme.sizing.scale100
  }}>
      {groupedPendingItems.length > 0 && <ItemAccordionSection title={`Pending (${pendingItems.length})`} testIdPrefix="pending" isExpanded={expandedSection === ACCORDION_SECTIONS.PENDING} onToggle={() => toggleSection(ACCORDION_SECTIONS.PENDING)} groupedItems={groupedPendingItems} navigationConfig={navigationConfig} renderItemActions={renderItemActions} groupingConfig={groupingConfig} />}
      {groupedPendingItems.length > 0 && groupedErrorItems.length > 0 && <div style={{
      borderBottom: `1px solid ${theme.colors.borderOpaque}`,
      margin: `0 -${theme.sizing.scale600}`
    }} />}
      {groupedErrorItems.length > 0 && <ItemAccordionSection title={`Errors (${errorItems.length})`} testIdPrefix="errors" isExpanded={expandedSection === ACCORDION_SECTIONS.ERRORS} onToggle={() => toggleSection(ACCORDION_SECTIONS.ERRORS)} groupedItems={groupedErrorItems} navigationConfig={navigationConfig} renderItemActions={renderItemActions} groupingConfig={groupingConfig} validationState={validationState} />}
    </RemainingItemsContainer>;
};